"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insightDataLoaderFactory = void 0;
// (C) 2021 GoodData Corporation
var util_1 = require("@gooddata/util");
var sdk_model_1 = require("@gooddata/sdk-model");
var constants_1 = require("./constants");
var DataLoaderAbstractFactory_1 = require("./DataLoaderAbstractFactory");
var InsightDataLoader = /** @class */ (function () {
    function InsightDataLoader(workspace) {
        this.workspace = workspace;
        this.insightCache = new util_1.LRUCache({ maxSize: constants_1.INSIGHT_CACHE_SIZE });
    }
    InsightDataLoader.prototype.getInsight = function (backend, ref) {
        var _this = this;
        var cacheKey = sdk_model_1.objRefToString(ref);
        var insight = this.insightCache.get(cacheKey);
        if (!insight) {
            insight = backend
                .workspace(this.workspace)
                .insights()
                .getInsight(ref)
                .catch(function (error) {
                _this.insightCache.delete(cacheKey);
                throw error;
            });
            this.insightCache.set(cacheKey, insight);
        }
        return insight;
    };
    return InsightDataLoader;
}());
/**
 * @internal
 */
exports.insightDataLoaderFactory = DataLoaderAbstractFactory_1.dataLoaderAbstractFactory(function (workspace) { return new InsightDataLoader(workspace); });
//# sourceMappingURL=InsightDataLoader.js.map